export enum MenuItemEvents {
  MenuItemClicked = 'menu_click',
}
